export const changeActive = "Do you want to change status?";
export const cancelClaim = "Do you want to cancel claim?";
export const changeActiveForRuCreationList =
	"If Target is inactivated then it won't be reflects in system";
export const aaproveMessage = "Do you want to Approve Request?";
export const closeMessage = "Do you want to Close Request?";
export const beatsAssign = "Some beats are assigned";
export const sendOrder = "Do you want to send order?";
export const approveOrder = "Do you want to approve this order?";
export const serverMsg = "Something went wrong";
export const creditLimitMsg = "Credit Limit Not Available";
export const generateBillMsg = "Do you want to generate invoice?";
export const cancelBillMsg = "Do you want to cancel invoice?";
export const approveClaimMsg = "Do you want to approve this claim?";
export const approveLeaveMsg = "Do you want to approve this leave?";
export const rejectClaimMsg = "Do you want to reject this claim?";
export const rejectLeaveMsg = "Do you want to reject this leave?";
export const cancelLeaveMsg = "Do you want to cancel this leave?";
export const syncMsg = "Sync Successfully";
export const uomNameMsg = "*UOM Name Required";
export const beatAssignedMsg = "Beat assigned to sales person";
export const imageMsg = "* Image not uploaded";
export const attachementMsg = "Do you want to upload attachement ?";
export const attachementSuccessMsg = "Attachement uploaded successfully";
export const pdfMsg = "* PDF not uploaded";
export const savemsg = "Save Successfully";
export const nameAlreadyExistMsg = "Name Already Exist";
export const updateMsg = "Data updated Successfully";
export const tokenMsg = "Token cleared Successfully";
export const saveFailedMsg = "Save Failed";
export const updateFailed = "Update Failed";
export const challanSettledMsg = "Challan Settled";
export const deletemsg = "Delete Successfully";
export const exportmsg = "Export Successfully";
export const importWarningMsg = "Do you want to import the validated records?";
export const importedSuccessfullyMsg = "Imported Successfully";
export const noValidatedRecordsFoundMsg = "No validated records found";
export const importmsg = "Import Successfully";
export const importedMsg = "Imported successfully";
export const importFailedMsg = "Import failed";
export const rejectMsg = "Order Rejected Successfully";
export const acceptMsg = "Order Accepted Successfully";
export const statusmsg = "Status updated";
export const orderApprovedMsg = "Order Approved";
export const challanCancelMsg = "Do You Want To Cancel This Challan ?";
export const statusFailedMsg = "Failed to change status";
export const deleteFailedMsg = "Delete Failed";
export const dobEmptyMsg = "Enter date of birth";
export const userNameEmptyMsg = "Enter username";
export const alreadyCheckedInMsg = "Already Cheked In";
export const enterPasswordMsg = "Enter password";
export const remarkMsg = "*Remark Required";
export const confirmPasswordIncorrectMsg = "*Confirm Password does not match";
export const confirmPasswordMsg = "Confirm Password required";
export const otpEmptyMsg = "Enter OTP";
export const otpFormatMsg = "OTP should be 6 digits only";
export const accessRoleMsg = "*Access role name required";
export const shortNameMsg = "*Short name required";
export const stackHolderTypeMsg = "*Stack Holder Type required";
export const regionMsg = "*Region required";
export const stateMsg = "*State required";
export const zoneMsg = "*Zone required";
export const districtMsg = "*District required";
export const talukaMsg = "*Taluka required";
export const areaMsg = "*Area required";
export const whoCanTakeMsg = "*Who can take required";
export const questionMsg = "*Question required";
export const sortOrderNoMsg = "*Sort order no required";
export const optionType = "*Select option type";
export const pointsMsg = "*Select points";
export const option = "*Option required";
export const dateMsg = "*Date required";
export const noInternetMsg = "Please check internet connection";
export const saveWarningMsg = "Do you want to save this record?";
export const taBeatDoesNotHaveTAAmount = "This beat does not have a TA amount";
export const saveWarningMsgForClaimManagement =
	"Some selected TA beats have a zero TA amount. Do you want to continue?";
export const saveWarningMsgForClaimApplying =
	"Submitting this action will delete the previously applied claim. Do you want to continue?";
export const challanSettleWarningMsg = "Do you want to settle this challan?";
export const closeWarningMsg = "Do you want to close this?";
export const saveWarningPlacedOrderMsg =
	"Purchase order amount is greater than credit limit still you want to process?";
export const sendPlacedOrderMsg =
	"Your purchase order amount is greater than credit limit, You can't send order";
export const deleteWarningMsg = "Do you want to delete this record?";
export const deleteWarningMsgForClaim = "Do you want to delete this claim?";
export const deleteErrorMsg = "Cannot delete record";
export const saveAndCloseWarningMsg =
	"Do you want to save and close this record?";
export const maxRecordMsg =
	"Cannot add more rows. The last record's 'To Date' is equal to the maximum date.";
export const debitAmountMsg = "*Amount required";
export const checkedListEmptyMsg = "*Select atleast one record";
export const addAtleastOneRecordMsg = "Please add atleast one record";
export const incompleteAssignErrorMsg = "Incomplete Assignation!";
export const checkedListMsg = "*Please select record";
export const checkedListForProductMsg =
	"*Please add rate atleast for one product";
export const debitAmountNotValidMsg =
	"*Amount should be less or equal to pending amount";
export const debitAmountZeroMsg = "*Amount should be greater than 0";
export const transactionDateMsg = "*Transaction date required";
export const feesStructureHeaderMsg = "*Fees structure required";
export const feesMinimumPayMsg =
	"*Amount should be greater than minimum paid amount";
export const feesMaximumPayMsg = "*Amount should be less than pending amount";
export const feesEqualPayMsg = "*Amount should be equal to pending amount";
export const numberMsg = "*Transaction id required";
export const bankNameMsg = "*Bank name required";
export const bankBranchMsg = "*Bank branch required";
export const ifscCodeMsg = "*IFSC code required";
export const micrCodeMsg = "*MICR code required";
export const sendCredentialMsg = "Do yo like to send credential to user";
export const generateCredentialMsg = "Credential generated successfully";
export const receiveBillSuccess = "Bill received successfully";
export const FailTogenerateCredentialMsg = "Failed to generate credential";
export const modeOfPayMsg = "*Mode of Pay required";
export const deleteConfirmMsg =
	"Once deleted, Information can not be Retrieved. Would you like to continue?";
export const dateExistMsg = "Rate configration already added for this date";
export const beatNotAssignMsg = "Beats not assigned for this sales team";
export const beatSelectMsg = "Select atleast one beat";
export const cancelledMsg = "Bill Cancelled Successfully";
export const cancelledChallanMsg = "Challan Cancelled Successfully";
export const atleastOne = "Please add atleast one product";
export const stockMsg = "Please add stock for proceed";
export const updateData = "Do you want to update this record?";
export const clearToken = "Do you want to clear this token?";
export const enterValueMsg = "Please add some data";
export const yearEndMsg = "Year end successfully";
export const outletInactiveMsg = "Do you want to in-active the outlets?";
export const nameMsg = "Please Enter Name";
export const vehicleNoMsg = "Please Enter Vehicle Number";
export const poNoMsg = "Please Enter Po Number";
export const transporterMsg = "Please Enter Transporter";
export const transporterIdMsg = "Please Enter Transporter Id";
export const lrRrGrNoMsg = "Please Enter LR/RR/GR No";
export const eWayBillNoMsg = "Please Enter E-Way Bill No";
export const poDateMsg = "Please Enter Po Date";
export const lrRrGrDateMsg = "Please Enter LR/RR/GR Date";
export const eWayBillDateMsg = "Please Enter E-Way Bill Date";
export const linkMsg = "Please Enter Link";
export const jsonMsg = "Please Enter Json";
export const contactNoMsg = "Enter Contact Number";
export const emailIdMsg = "Enter Email ID";
export const addressMsg = "Enter Address";
export const gstNumberMsg = "Enter GST Number";
export const panNumberMsg = "Enter PAN Number";
export const cinNumberMsg = "Enter CIN Number";
export const invoicePrefixMsg = "Enter Invoice Prefix";
export const fdiFssiNumberMsg = "Enter FDI FSSI Number";
export const descriptionMsg = "Enter Description";
export const fromdateMsg = "From Date Is Required";
export const todateMsg = "To Date Is Required";
export const levelwiseTypeMsg = "Level-Wise Type Is Required";
export const applicableAmountMsg = "Applicable Amount Is Required";
export const flatAmountMsg = "Flat Amount Is Required";
export const unitValueMsg = "Unit Value Is Required";
export const applicableAmountGreaterThanZeroMsg =
	"Applicable Amount should be greater than 0";
export const discountAmountMsg = "Discount Amount Is Required";
export const discountAmountErrorMsg =
	"Discount Amount Must Be Less Than Applicable Amount";
export const discountAmountGreaterThanZeroMsg =
	"Discount Amount should be greater than 0";
export const discountPercentageMsg = "Discount Percentage Is Required";
export const discountPercentageGreaterThanZeroMsg =
	"Discount Percentage should be greater than 0";
export const percentageMsg = "Percentage Is Required";
export const productMsg = "Please Select Product";
export const productRemainingMsg = "Few product are remaining to add";
export const batchMsg = "Please Select Batch";
export const batchEmptyMsg = "Please Enter Batch";
export const productByCategoryMsg = "Please Select Product";
export const qtyMsg = "Quantity Is Required";
export const minQtyMsg = "Min Quantity Is Required";
export const maxQtyMsg = "Max Quantity Is Required";
export const qtyForItemMsg = "Quantity Is Required";
export const qtyGreaterThanZeroMsg = "Quantity should be greater than 0";
export const minQtyGreaterThanZeroMsg = "Min Quantity should be greater than 0";
export const maxQtyGreaterThanZeroMsg = "Min Quantity should be greater than 0";
export const flatAmtGreaterThanZeroMsg = "Flat amount should be greater than 0";
export const unitValueGreaterThanZeroMsg =
	"Unit value should be greater than 0";
export const qtyGreaterThanBillQtyMsg =
	"Quantity should be less than or equals to bill quantity";
export const discountPercentageErrorMsg =
	"Discount Percentage Must Be Less Than Or Equal 100";
export const ReportMsg = "*Report required";
export const apiNameMsg = "*API Name required";
export const billAlreadyGeneratedMsg = "*Bill is already generated";
export const paramsValueMsg = "*Parameter Value required";
export const paramsKeyMsg = "*Parameter Key required";
export const reportTypeMsg = "*Report Type Required";

export const controlTypeMsg = "*Control Type required";
export const labelMsg = "*Label required";
export const placeHolderMsg = "*Placeholder required";
export const fieldNameMsg = "*Field Name required";
export const claimTypeName = "*Claim Type Name required";
export const fieldNameUniqueMsg = "*Field Name should be unique";

export const pojoFieldNameMsg = "*Pojo Field Name required";

export const keyMsg = "*Key required";
export const urlMsg = "*URL required";
export const localListMsg = "Please add atlest one object";
export const columnNameMsg = "*Column Name required";
export const widthMsg = "*Width required";
export const sortNoMsg = "*Sort number required";
export const valueMsg = "*Value required";
export const graphTypeMsg = "*Graph Type required";
export const sortOrderMsg = "Sort Order required";
export const parameterKeyMsg = "*Parameter key required";
export const parameterValueMsg = "*Parameter value required";
export const addAtleastProductMsg = "Please add atleast one product";
export const authenticationMsg =
	"You are no longer active, please contact to admin. ";
export const publishDateMsg =
	"Rate Structure is already presented for this date for selected stock holder";
export const rateStructurePesentedMsg =
	"Selected rate structure is already presented for this date";
export const closedOrderWarningInHindi =
	"क्या आप उपरोक्त ऑर्डरों को बंद करना चाहेंगे जो स्टॉक में नहीं हैं और शेष के साथ आगे बढ़ना चाहेंगे ?";
export const closedOrderWarningInGujrati =
	"ઉપરોક્ત products માંથી તમે LOST ORDER કરી ને, બિલ કાઢવા માંગો છો?";
export const closedOrderWarning =
	"Would you like to close above orders that are out of stock and proceed with remaining ?";
export const userOldPassEmptyMsg = "Enter Old Password";
export const previousAmountError =
	"Entered amount is must be greater than previous amount";
export const alreadyLoggedIn = "You are already loggedIn on another device";
export const notCheckInYet = "Sales Person Not Check In Yet";
export const cashMsg = "Please Enter Cash Amount";
export const onlineMsg = "Please Enter Online Amount";
export const cashAmtMsg = "Enter amount must be equal to outstanding amount";
export const onlineAmtMsg = "Enter amount must be equal to outstanding amount";
export const otherTaskMsg = "Other Task Required";
export const addOneRecordMsg = "Add Atleast One Record";
export const dateValidationMsg = "From Date Should Be Less Than To Date";
export const dataNotFoundMsg = "Data Not Found";
export const costRequiredMsg = "Cost Required";
export const costGreaterThanZeroMsg = "Cost Should be greater than zero";
export const venderRequiredMsg = "Vender Required";
export const approvedAssetsQtyMsg = "Approve Assets Quantity Required";
export const productNameMSG = "Product Name Required";
export const pdfNameMSG = "PDF Name Required";
export const productMrpMSG = "Product MRP Required";
export const productRetailMsg = "Product Retail Rate Required";
export const launchDateMsg = "Launch Date Required";
export const offerMsg = "Offer Required";
export const cdMsg = "CD Required";
export const closedMsg = "Closed Successfully";
export const productDescriptionMsg = "Product Descripion Required";
export const watcherMsg = "Add Atleast One Watcher";
export const headerMsg = "Header Required";
export const addAtleastOneMomMsg = "Add Atleast One Mom Details";
export const checkBoxSelectMsg = "Selct atleast one checkbox option";
export const sessionMsg = "Session Expired !";
export const languageNotAvailableMsg = "Language Json not available";
export const selectOneRecordOnlyMsg = "Please Select One Record Only";
export const convertMessage =
	"Do you want to convert this request into stock holder ?";
export const scrollMsg = "Please scroll down to enter the details";
export const days31Validation =
	"Please select the To Date within 31 days of the From Date.";
export const days7Validation =
	"Please select the To Date within 7 days of the From Date.";
export const offerSelectionMsg =
	"Please select at least one offer to generate credit note.";
export const nameAlreadyPresentMsg = "Name Already Present";
export const genrateCRNMsg =
	"Do you want to approve and generate a credit note ?";
export const genratedCRNMsg = "Credit note genrated successfully.";
export const settingValueMsg = "Setting Value Required";
export const vehicleRequiredMsg = "Please Select Vehicle";
export const validatedSuccessfullyMsg = "Valiated Successfully";
export const errorAtValidationMsg =
	"Errors found while validating this import file. Please correct them and re-import.";
export const checkMandatoryFieldsInTableMsg =
	"Please check the mandatory fields in the table";
export const optionalHolidayLimitExceed = "Optional holiday limit is exceeded";
export const toDateCannotBeLessThanFromDateMsg =
	"To Date cannot be less than From Date";
export const leaveAlreadyAppliedMsg = "Leave Already Applied";
export const areYouSureMsg = "Are You Sure?";
export const approvedSuccessfullyMsg = "Approved Successfully";
export const rejectedSuccessfullyMsg = "Rejected Successfully";
export const selectPendingClaimMsg = "Please select pending claims";
export const noPathAvailableMsg =
	"No path available. Please select a tracking path first.";
export const pleaseSelectCheckInAndCheckOutTimeMsg =
	"Please select check in and check out time";
export const pleaseAllowLocationMsg = "Please allow location";
export const pleaseSelectAtLeastOneOutletMsg =
	"Please select at least one outlet";
export const fetchingAddressMsg = "Fetching address...";
export const thisFieldIsRequiredMsg = "This field is required";
export const checkRequiredFieldsMsg =
	"Please check required fields of selected records.";
export const addressNotAvailableMsg = "Address not available";
export const importStockHolderMsg = "Import Stock Holder";
export const convertSuccessFullyMsg = "Converted Successfully";
export const convertEnquiryMsg = "Do you want to convert this enquiry?";
export const selectAtleastOneEnquiryMsg =
	"Please select at least one enquiry to convert.";
export const updateTextButtonMsg = "Update";
export const saveTextButtonMsg = "Save";
export const convertTextButtonMsg = "Convert";
export const searchButtonMsg = "Search";
export const selectExcelFileMsg = "Select the Excel File to import data.";
export const importTxt = "Import";
export const exportTxt = "Export";
export const excelExportedSuccessfullyMsg = "Excel exported successfully";
export const excelImportedSuccessfullyMsg = "Excel imported successfully";
export const importOutletEnquiryMsg = "Import Outlet Enquiry";
export const importRuWiseTargetMsg = "Import RU Wise Target";
export const importStockHolderEnquiryMsg = "Import Stock Holder Enquiry";
export const noDataFoundMsg = "No Data Found";
export const importHolidayStructureAssignationMsg =
	"Import Holiday Structure Assignation";
export const showingCarryForwardDetailsForMsg =
	"Displaying carry-forward details for the ";
export const enquiryAlreadyConvertedMsg =
	"Selected enquiry is already converted";
export const salesTeamExcelReportsNote =
	"Choose the particular filters mentioned in order to generate the report.";
export const salesTeamExcelReportsNoteWith31DaysValidation =
	"Select a date range within 31 days and apply the required filters to generate the report.";
export const salesTeamExcelReportsNoteWith91DaysValidation =
	"Select a date range within 91 days and apply the required filters to generate the report.";
export const challanLifeCycleTimelineMsg = "Challan Lifecycle Timeline";
export const payment = "Payment";
export const cancelChallan = "Cancel Challan";
export const deleteChallan = "Delete Challan";
export const challanSettlement = "Challan Settlement";
export const downloadPDF = "Download PDF";
export const downloadCSV = "Download CSV";
export const createdMsg = "● Created";
export const assignedMsg = "● Assigned";
export const beatMsg = "● Beat";
export const topProductsByRevenue = "Top Products by Revenue";
export const noProductsAvailableMsg = "No products available";
export const noChallanMatchedYourFilterMsg = "No challans found.";
export const pendingChallanCanBeEdit = "Only Pending challans can be edit";
export const youAreOnApprovedLeaveMsg =
	"Sales Team is on approved leave, so check-in is not permitted!";
export const cumulativeNegativeDifferenceMsg = "Cumulative negative difference";
export const enterPhysicalCountsAboveMsg = "Enter physical counts above";
export const rateDamageQtyMsg = "Rate × damaged qty (cumulative)";
export const computedOnSave = "Computed on save";
export const checkBothDriverAndSettlerMsg =
	"Please check both Driver & Settler to proceed.";
export const noInvoiceLinkedMsg = "No invoice linked";
export const verifiedAgainstBankStatementMsg =
	"Verified against bank statement";
export const insuffiecientFundMsg = "Insufficient funds";
export const chequeIsOnHoldMsg =
	"Cheque is on hold — pending further review by admin.";
export const validationHaltedMsg =
	"Skipped — validation halted at a previous step.";
export const physicalEntryErrorMsg =
	"User has not done Physical return entry at Stock reconciliation before submitting. Please go back and complete the physical count entry for all SKUs";
export const validationRunningMsg = "Validation running…";
export const allCheckPassedMsg = "All checks passed. Ready to save.";
export const warningFoundMsg = "Warnings found — review before saving.";
export const validationFailedMsg =
	"Validation failed. Fix errors before submission.";
export const doNotCloseValdationWindowMsg =
	"Do not close this window during validation";
export const allValidationPassedMsg = "All validations passed.";
export const submmisionBlockedMsg =
	"Submission blocked. Resolve the errors above and try again.";
export const fullCollectionConfirmedMsg =
	"Full collection confirmed. Payment settlement cleared.";
export const loadingDetailsMsg = "Loading details…";
export const noDetailsAvailableForThisChallanMsg =
	"No details available for this challan.";
export const editChallan = "Edit Challan";
export const pendingChallanCanBeCancel = "Only Pending challans can be cancel";
export const activeChallanCanBeSettle = "Only Active Challan Can Be Settle";
export const pendingChallanCanBeDelete = "Only Pending challans can be delete";
export const damageReturnsPlaceholder =
	"e.g. BESAN 200GM — 1 packet found open on van, seal broken. Likely damaged during transit near Sanosara route…";
export const noStockTransferDetailsForChallanMsg =
	"No stock transfer details available for this challan.";
export const stockReconciliationTitleMsg =
	"Stock reconciliation — physical count entry";
export const noSkusBadgeMsg = "No SKUs";
export const allMatchedMsg = "All matched";
export const stockUnitMismatchSuffixMsg = "unit mismatch";
export const settlerInstructionLabelMsg = "Settler instruction:";
export const settlerInstructionBodyMsg =
	"Count every item physically on the van and enter the actual return qty below. System auto-calculates any difference from expected.";
export const stockReconciliationFootnoteMsg =
	"Enter physical return count for each SKU after counting items on the van. Rows highlight automatically when a mismatch is detected.";
export const searchProductsByNamePlaceholderMsg = "Search products by name...";
export const viewProductDetailsMsg = "View product details";
export const noProductsMatchSearchMsg = "No products match";
export const vehicleSelectMsg =
	"Please select a vehicle. If no vehicles are available, they are currently assigned or in use.";
export const dueToStockShortageOfferIsNotApplicableMsg =
	"Due to a shortage of stock, the offer is not applicable";
export const noRecordsFoundMsgForOutletInvoicing =
	"No records found. Use the filter above to search orders.";
export const negativeProductListTitleMsg = "Negative Product List";
export const confirmOutOfStockOrdersTitleMsg = "Confirm Out of Stock Orders";
export const negativeProductListSubtitleMsg =
	"Products with insufficient stock for billing";
export const confirmOutOfStockOrdersSubtitleMsg =
	"Review items below and confirm to close out-of-stock orders";
export const negativeProductListSearchPlaceholderMsg =
	"Search products, outlets, orders...";
export const noNegativeProductFoundMsg = "No negative product found";
export const confirmBeforeProceedingMsg = "Please confirm before proceeding";
export const negativeProductListItemsLabelMsg = "items";
export const lostAndProceedBtnMsg = "Lost and Proceed";
export const proceedForBillingBtnMsg = "Proceed For Billing";
